<template>
  <div class="tip-lamp-container">
    <div
      v-show="isShowTipResult"
      class="tip-lamp-panel"
      v-html="tipResult"
    ></div>
    <div class="tip-lamp-icon" @click="changeTip">
      <svg
        v-if="isTip"
        t="1732183902060"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="12192"
        width="32"
        height="32"
      >
        <path
          d="M158.969786 345.90143zM350.188819 666.981806c-77.205609-39.873798-137.773303-107.405457-168.693147-189.473042 30.917844 82.067585 91.485537 149.599243 168.693147 189.473042 15.167923 7.83396 27.75986 19.197903 37.125812 32.767834-9.365953-13.569931-21.955889-24.933874-37.125812-32.767834zM400.092566 724.935513zM590.187604 424.653032c-9.295953 1.89199-15.149923 6.561967-23.023883 12.865935-11.983939 9.585952-26.903864 21.517891-55.163721 21.517891s-43.179782-11.92994-55.163721-21.517891c-7.87396-6.305968-13.725931-10.973944-23.023883-12.865935l60.247695 331.364324c0.191999 1.061995 0.269999 2.113989 0.271998 3.155984h35.335822c0-1.041995 0.08-2.093989 0.271998-3.155984l60.247695-331.364324zM171.835721 259.169869z"
          fill="#FFCD73"
          p-id="12193"
        />
        <path
          d="M493.246095 0.491178a360.408177 360.408177 0 0 1 40.335796 0.221998C415.488488 11.365123 320.19897 163.734352 317.838982 345.90143c-1.807991 139.605294 49.071752 261.178679 124.117372 320.936377l-53.25973-292.920518c-1.741991-9.585952 4.621977-18.775905 14.213928-20.517897 9.541952-1.87999 18.785905 4.603977 20.525896 14.207928l3.799981 20.903895c25.979869 0.951995 40.175797 12.247938 51.647739 21.423891 10.379947 8.311958 17.233913 13.79393 33.111832 13.793931s22.733885-5.481972 33.111833-13.793931c11.471942-9.175954 25.66787-20.473896 51.647738-21.423891l3.799981-20.903895c1.741991-9.603951 10.913945-16.067919 20.525896-14.207928a17.647911 17.647911 0 0 1 14.213928 20.517897l-70.047645 385.258051h52.675733v1.067994c0-39.127802 21.395892-75.411619 56.145716-93.395527 113.467426-58.723703 191.027034-177.161104 191.027034-313.740413C865.102214 151.876412 696.777065-10.034769 493.246095 0.491178zM400.288565 725.56751l0 0z"
          fill="#FFCD73"
          p-id="12194"
        />
        <path
          d="M456.836279 437.516967c11.983939 9.585952 26.903864 21.517891 55.163721 21.517891s43.179782-11.92994 55.163721-21.517891c7.87396-6.305968 13.725931-10.973944 23.023883-12.865935l6.571967-36.143817c-25.979869 0.951995-40.175797 12.247938-51.647738 21.423891-10.379947 8.311958-17.233913 13.79393-33.111833 13.793931s-22.733885-5.481972-33.111833-13.793931c-11.471942-9.175954-25.66787-20.473896-51.647738-21.423891l6.571967 36.143817c9.293953 1.89199 15.149923 6.561967 23.023883 12.865935z"
          fill="#FFFFFF"
          p-id="12195"
        />
        <path
          d="M406.068536 759.17334h52.675733l-16.787915-92.335533c-75.04562-59.755698-125.925363-181.327083-124.117372-320.936377C320.19897 163.734352 415.488488 11.365123 533.581891 0.713176a359.924179 359.924179 0 0 0-40.335796-0.221998c-0.094 0.004-0.189999 0.006-0.283999 0.011999C342.404858 8.405137 215.615499 113.712605 173.657712 252.891901a352.620216 352.620216 0 0 0-1.821991 6.277968c-0.357998 1.267994-0.725996 2.531987-1.069995 3.803981a345.588252 345.588252 0 0 0-11.79794 82.92558 355.578201 355.578201 0 0 0 5.277973 68.469654 350.298228 350.298228 0 0 0 17.249913 63.14168c30.917844 82.065585 91.487537 149.597243 168.693147 189.473042 15.167923 7.83396 27.75986 19.195903 37.125812 32.767834 0.101999 0.147999 0.189999 0.303998 0.289998 0.451998a105.691465 105.691465 0 0 1 12.485937 24.731875c0.072 0.207999 0.125999 0.423998 0.195999 0.631997a107.209458 107.209458 0 0 1 5.779971 34.685824v-1.081994h0.002z"
          fill="#FFB969"
          p-id="12196"
        />
        <path
          d="M476.690179 759.17334h17.64191c0-1.041995-0.08-2.093989-0.271998-3.155984l-60.247695-331.364324-6.571967-36.143817-3.799981-20.903895c-1.741991-9.603951-10.983944-16.085919-20.525896-14.207928a17.647911 17.647911 0 0 0-14.213928 20.517897l53.25973 292.920518 16.787915 92.335533h17.94391v0.002zM529.939909 756.019356a17.86391 17.86391 0 0 0-0.271998 3.155984h35.58582l70.047645-385.258051c1.741991-9.585952-4.621977-18.775905-14.213928-20.517897-9.611951-1.861991-18.785905 4.603977-20.525896 14.207928l-3.799981 20.903895-6.571967 36.143817-60.249695 331.364324z"
          fill="#FFE8C0"
          p-id="12197"
        />
        <path
          d="M476.690179 988.690179c0 19.501901 15.80792 35.309821 35.309821 35.309821 19.501901 0 35.309821-15.80792 35.309821-35.309821v-17.655911h-70.619642v17.655911z"
          fill="#96A5B9"
          p-id="12198"
        />
        <path
          d="M476.690179 872.818765l138.945297-19.8479a17.87791 17.87791 0 0 1 2.295988-0.163999v-35.475821l-141.241285 20.177898v35.309822zM406.330535 918.060536c0.048 0.407998 0.098 0.815996 0.157999 1.221994-0.058-0.405998-0.107999-0.813996-0.157999-1.221994zM425.586437 945.484397zM407.680528 924.386504zM565.253731 759.17334h-88.563552v43.025782l138.945297-19.8479a17.87791 17.87791 0 0 1 2.295988-0.163999V759.17334h-52.677733zM476.690179 908.128586v5.769971a35.309821 35.309821 0 0 0 19.519901 31.58384l51.099741 25.551871 51.099742-25.551871a35.305821 35.305821 0 0 0 19.519901-31.58384v-25.947869l-141.239285 20.177898z"
          fill="#BEC8DC"
          p-id="12199"
        />
        <path
          d="M476.690179 759.17334h-70.621643v53.115731l70.621643-10.089949zM476.690179 837.508943l-68.325655 9.761951a17.87791 17.87791 0 0 1-2.295988 0.163999v35.475821l70.621643-10.087949v-35.313822zM476.690179 913.902557v-5.771971l-68.325655 9.761951a17.579911 17.579911 0 0 1-2.029989 0.167999c0.048 0.407998 0.098 0.815996 0.157999 1.221994a35.355821 35.355821 0 0 0 1.185994 5.107974 35.307821 35.307821 0 0 0 13.633931 18.571906 35.219822 35.219822 0 0 0 4.271978 2.525987l51.099742 25.551871h70.619642l-51.099741-25.551871a35.325821 35.325821 0 0 1-19.513901-31.58584z"
          fill="#AAB6CA"
          p-id="12200"
        />
        <path
          d="M615.635476 852.970865l-138.945297 19.8479-70.619643 10.087949-2.647987 0.379998a17.475912 17.475912 0 0 0-15.005924 17.301912c0 9.94595 8.237958 17.73191 17.91991 17.469912a17.579911 17.579911 0 0 0 2.029989-0.167999l68.325655-9.761951 141.241285-20.177898 2.647987-0.379998a17.475912 17.475912 0 0 0 15.005924-17.301912c0-9.85595-8.089959-17.577911-17.655911-17.465912a18.283908 18.283908 0 0 0-2.295988 0.167999zM615.635476 782.349222l-138.945297 19.8479-70.619643 10.087949-2.647987 0.379998a17.475912 17.475912 0 0 0-15.005924 17.301913c0 9.85595 8.089959 17.577911 17.655911 17.465911a17.279913 17.279913 0 0 0 2.295988-0.163999l68.325655-9.761951 141.241285-20.177898 2.647987-0.379998a17.475912 17.475912 0 0 0 15.005924-17.301912c0-9.85595-8.089959-17.577911-17.655911-17.465912-0.759996 0.014-1.525992 0.058-2.297988 0.167999z"
          fill="#96A5B9"
          p-id="12201"
        />
      </svg>
      <svg
        v-else
        t="1732183962525"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="12646"
        width="32"
        height="32"
      >
        <path
          d="M158.969786 345.90143zM350.188819 666.981806c-77.205609-39.873798-137.773303-107.405457-168.693147-189.473042 30.917844 82.067585 91.485537 149.599243 168.693147 189.473042 15.167923 7.83396 27.75986 19.197903 37.125812 32.767834-9.365953-13.569931-21.955889-24.933874-37.125812-32.767834zM400.092566 724.935513zM590.187604 424.653032c-9.295953 1.89199-15.149923 6.561967-23.023883 12.865935-11.983939 9.585952-26.903864 21.517891-55.163721 21.517891s-43.179782-11.92994-55.163721-21.517891c-7.87396-6.305968-13.725931-10.973944-23.023883-12.865935l60.247695 331.364324c0.191999 1.061995 0.269999 2.113989 0.271998 3.155984h35.335822c0-1.041995 0.08-2.093989 0.271998-3.155984l60.247695-331.364324zM171.835721 259.169869z"
          fill="#cdcdcd"
          p-id="12647"
        />
        <path
          d="M493.246095 0.491178a360.408177 360.408177 0 0 1 40.335796 0.221998C415.488488 11.365123 320.19897 163.734352 317.838982 345.90143c-1.807991 139.605294 49.071752 261.178679 124.117372 320.936377l-53.25973-292.920518c-1.741991-9.585952 4.621977-18.775905 14.213928-20.517897 9.541952-1.87999 18.785905 4.603977 20.525896 14.207928l3.799981 20.903895c25.979869 0.951995 40.175797 12.247938 51.647739 21.423891 10.379947 8.311958 17.233913 13.79393 33.111832 13.793931s22.733885-5.481972 33.111833-13.793931c11.471942-9.175954 25.66787-20.473896 51.647738-21.423891l3.799981-20.903895c1.741991-9.603951 10.913945-16.067919 20.525896-14.207928a17.647911 17.647911 0 0 1 14.213928 20.517897l-70.047645 385.258051h52.675733v1.067994c0-39.127802 21.395892-75.411619 56.145716-93.395527 113.467426-58.723703 191.027034-177.161104 191.027034-313.740413C865.102214 151.876412 696.777065-10.034769 493.246095 0.491178zM400.288565 725.56751l0 0z"
          fill="#e6e6e6"
          p-id="12648"
        />
        <path
          d="M456.836279 437.516967c11.983939 9.585952 26.903864 21.517891 55.163721 21.517891s43.179782-11.92994 55.163721-21.517891c7.87396-6.305968 13.725931-10.973944 23.023883-12.865935l6.571967-36.143817c-25.979869 0.951995-40.175797 12.247938-51.647738 21.423891-10.379947 8.311958-17.233913 13.79393-33.111833 13.793931s-22.733885-5.481972-33.111833-13.793931c-11.471942-9.175954-25.66787-20.473896-51.647738-21.423891l6.571967 36.143817c9.293953 1.89199 15.149923 6.561967 23.023883 12.865935z"
          fill="#cdcdcd"
          p-id="12649"
        />
        <path
          d="M406.068536 759.17334h52.675733l-16.787915-92.335533c-75.04562-59.755698-125.925363-181.327083-124.117372-320.936377C320.19897 163.734352 415.488488 11.365123 533.581891 0.713176a359.924179 359.924179 0 0 0-40.335796-0.221998c-0.094 0.004-0.189999 0.006-0.283999 0.011999C342.404858 8.405137 215.615499 113.712605 173.657712 252.891901a352.620216 352.620216 0 0 0-1.821991 6.277968c-0.357998 1.267994-0.725996 2.531987-1.069995 3.803981a345.588252 345.588252 0 0 0-11.79794 82.92558 355.578201 355.578201 0 0 0 5.277973 68.469654 350.298228 350.298228 0 0 0 17.249913 63.14168c30.917844 82.065585 91.487537 149.597243 168.693147 189.473042 15.167923 7.83396 27.75986 19.195903 37.125812 32.767834 0.101999 0.147999 0.189999 0.303998 0.289998 0.451998a105.691465 105.691465 0 0 1 12.485937 24.731875c0.072 0.207999 0.125999 0.423998 0.195999 0.631997a107.209458 107.209458 0 0 1 5.779971 34.685824v-1.081994h0.002z"
          fill="#dbdbdb"
          p-id="12650"
        />
        <path
          d="M476.690179 759.17334h17.64191c0-1.041995-0.08-2.093989-0.271998-3.155984l-60.247695-331.364324-6.571967-36.143817-3.799981-20.903895c-1.741991-9.603951-10.983944-16.085919-20.525896-14.207928a17.647911 17.647911 0 0 0-14.213928 20.517897l53.25973 292.920518 16.787915 92.335533h17.94391v0.002zM529.939909 756.019356a17.86391 17.86391 0 0 0-0.271998 3.155984h35.58582l70.047645-385.258051c1.741991-9.585952-4.621977-18.775905-14.213928-20.517897-9.611951-1.861991-18.785905 4.603977-20.525896 14.207928l-3.799981 20.903895-6.571967 36.143817-60.249695 331.364324z"
          fill="#cdcdcd"
          p-id="12651"
        />
        <path
          d="M476.690179 988.690179c0 19.501901 15.80792 35.309821 35.309821 35.309821 19.501901 0 35.309821-15.80792 35.309821-35.309821v-17.655911h-70.619642v17.655911z"
          fill="#96A5B9"
          p-id="12652"
        />
        <path
          d="M476.690179 872.818765l138.945297-19.8479a17.87791 17.87791 0 0 1 2.295988-0.163999v-35.475821l-141.241285 20.177898v35.309822zM406.330535 918.060536c0.048 0.407998 0.098 0.815996 0.157999 1.221994-0.058-0.405998-0.107999-0.813996-0.157999-1.221994zM425.586437 945.484397zM407.680528 924.386504zM565.253731 759.17334h-88.563552v43.025782l138.945297-19.8479a17.87791 17.87791 0 0 1 2.295988-0.163999V759.17334h-52.677733zM476.690179 908.128586v5.769971a35.309821 35.309821 0 0 0 19.519901 31.58384l51.099741 25.551871 51.099742-25.551871a35.305821 35.305821 0 0 0 19.519901-31.58384v-25.947869l-141.239285 20.177898z"
          fill="#BEC8DC"
          p-id="12653"
        />
        <path
          d="M476.690179 759.17334h-70.621643v53.115731l70.621643-10.089949zM476.690179 837.508943l-68.325655 9.761951a17.87791 17.87791 0 0 1-2.295988 0.163999v35.475821l70.621643-10.087949v-35.313822zM476.690179 913.902557v-5.771971l-68.325655 9.761951a17.579911 17.579911 0 0 1-2.029989 0.167999c0.048 0.407998 0.098 0.815996 0.157999 1.221994a35.355821 35.355821 0 0 0 1.185994 5.107974 35.307821 35.307821 0 0 0 13.633931 18.571906 35.219822 35.219822 0 0 0 4.271978 2.525987l51.099742 25.551871h70.619642l-51.099741-25.551871a35.325821 35.325821 0 0 1-19.513901-31.58584z"
          fill="#AAB6CA"
          p-id="12654"
        />
        <path
          d="M615.635476 852.970865l-138.945297 19.8479-70.619643 10.087949-2.647987 0.379998a17.475912 17.475912 0 0 0-15.005924 17.301912c0 9.94595 8.237958 17.73191 17.91991 17.469912a17.579911 17.579911 0 0 0 2.029989-0.167999l68.325655-9.761951 141.241285-20.177898 2.647987-0.379998a17.475912 17.475912 0 0 0 15.005924-17.301912c0-9.85595-8.089959-17.577911-17.655911-17.465912a18.283908 18.283908 0 0 0-2.295988 0.167999zM615.635476 782.349222l-138.945297 19.8479-70.619643 10.087949-2.647987 0.379998a17.475912 17.475912 0 0 0-15.005924 17.301913c0 9.85595 8.089959 17.577911 17.655911 17.465911a17.279913 17.279913 0 0 0 2.295988-0.163999l68.325655-9.761951 141.241285-20.177898 2.647987-0.379998a17.475912 17.475912 0 0 0 15.005924-17.301912c0-9.85595-8.089959-17.577911-17.655911-17.465912-0.759996 0.014-1.525992 0.058-2.297988 0.167999z"
          fill="#96A5B9"
          p-id="12655"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "TipLamp",
  computed: {
    tipResult() {
      return this.$store.state.tipLamp.tipResult;
    },
    isShowTipResult() {
      return this.$store.state.tipLamp.isShowTipResult;
    },
    isTip() {
      return this.$store.state.tipLamp.isTip;
    },
  },
  methods: {
    changeTip() {
      if (!this.tipResult) {
        return;
      }
      const nextState = !this.$store.state.tipLamp.isShowTipResult;
      this.$store.commit("set_tip_show_result", nextState);
      this.$store.commit("set_tip_blink", false);
    },
  },
};
</script>

<style scoped>
.tip-lamp-container {
  pointer-events: none;
}

.tip-lamp-panel {
  position: fixed;
  width: 20%;
  right: 85px;
  top: 60px;
  background: #f3f7f3;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #cdcdcd;
  max-height: 300px;
  overflow-y: auto;
  z-index: 1000;
  pointer-events: auto;
}

.tip-lamp-icon {
  position: fixed;
  top: 55px;
  right: 45px;
  width: 35px;
  height: 35px;
  cursor: pointer;
  z-index: 1100;
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 50%;
}

.icon {
  width: 32px;
  height: 32px;
}
</style>